import React, { FC } from 'react';
import { BrowserRouter, Redirect, Route, RouteProps, Switch } from 'react-router-dom';
import { Global } from '@emotion/react';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { GlOBAL_RESET_CSS } from './styles/reset';
import { GlOBAL_COMMON_CSS } from './styles/common';

import LoginPage from './pages/Login/Login.index';
import HomePage from './pages/Home/Home.index';
import ReferralCodePage from './pages/ReferralCode/ReferralCode.index';
import CreditcardSwitchingPage from './pages/CreditcardSwitching/CreditcardSwitching.index';
import Unpaid from './pages/Unpaid/Unpaid.index';
import UnpaidPayment from './pages/Unpaid/Payment/Payment.index';
import Complete from './pages/Complete/Complete.index';
import OtherOptions from './pages/OtherOptions/OtherOptions.index';
import ReservationHistory from './pages/ReservationHistory/ReservationHistory.index';
import ShopList from './pages/ShopList/ShopList.index';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Reservation from './pages/Reservation/Reservation.index';

import RequestInformation from './pages/RequestInformation/RequestInformation.index';
import Receipt from './pages/Receipt/Receipt.index';

import Recess from './pages/Recess/Recess.index';
import Recess_Info from './pages/Recess/Rcess_Info/Recess.info';
import Month_start from './pages/Recess/Recess_Month_Start/Month.start';
import Month_end from './pages/Recess/Recess_Month_End/Month.end';
import Recess_agreement from './pages/Recess/Recess_Agreement/Recess.agreement';
import Recess_complete from './pages/Recess/Recess_Complete/Recess.complete';
import Recess_cancel_agreement from './pages/Recess/Recess_Cancel_Agreement/Recess.cancel.agreement';
import Recess_cancel_complete from './pages/Recess/Recess_Cancel_Complete/Recess.cancel.complete';
import Schedule from './pages/Schedule/Schedule.index';

import ErrorSystem from './pages/Error/ErrorSystem';
import Error404 from './pages/Error/Error404';
import ErrorPayment from './pages/Error/ErrorPayment';
import ErrorMail from './pages/Error/ErrorMail';
import { LOG_IN_REQUEST } from './store/actions';

// const loading = (
//   <div className="pt-3 text-center">
//     <div className="sk-spinner sk-spinner-pulse" />
//   </div>
// );

const App: FC = () => {
  const dispatch = useDispatch();
  type PrivateRouteProps = {
    component: React.ComponentType<any>;
  } & RouteProps;
  const OTHER_OPTIONS_PATHS = ['/receipt', '/referralCode'];
  const PrivateRoute = ({ component: Component, ...rest }: PrivateRouteProps) => {
    const location = useLocation();
    const memberIDFromSession = sessionStorage.getItem('memberID');
    if (!memberIDFromSession) {
      const jwtToken = localStorage.getItem('jwtToken');
      if (location.pathname !== '/') {
        if (
          OTHER_OPTIONS_PATHS.includes(location.pathname) ||
          location.pathname.startsWith('/creditcardSwitching') ||
          location.pathname.startsWith('/unpaid') ||
          location.pathname.startsWith('/recess')
        ) {
          localStorage.setItem('redirectPath', '/otherOptions');
        } else {
          localStorage.setItem('redirectPath', location.pathname);
        }
      }
      if (jwtToken && jwtToken.startsWith('Bearer ')) {
        // token check
        // sessionStorage.setItem('redirectPath', location.pathname);
        // sessionStorage.setItem('redirectSearch', location.search);
        // sessionStorage.setItem('redirectHash', location.hash);
        dispatch({
          type: LOG_IN_REQUEST,
          jwt_token: jwtToken,
          loginClass: 2,
        });
      }
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: location.pathname },
          }}
        />
      );
    }
    return <Route {...rest} render={(props) => <Component {...props} />} />;
  };
  return (
    <>
      <Global styles={GlOBAL_RESET_CSS} />
      <Global styles={GlOBAL_COMMON_CSS} />

      <BrowserRouter>
        <Switch>
          <Route path="/" component={LoginPage} exact />
          <Route path="/home" component={HomePage} exact />

          <PrivateRoute path="/referralCode" component={ReferralCodePage} exact />

          <PrivateRoute path="/creditcardSwitching" component={CreditcardSwitchingPage} exact />
          <PrivateRoute path="/creditcardSwitching/complete" component={Complete} exact />

          {/* 未納金お支払いの画面 */}
          <PrivateRoute path="/unpaid" component={Unpaid} exact />
          <PrivateRoute path="/unpaid/payment" component={UnpaidPayment} exact />
          <PrivateRoute path="/unpaid/payment/complete" component={Complete} exact />

          <PrivateRoute path="/systemError" component={ErrorSystem} />
          <PrivateRoute path="/paymentError" component={ErrorPayment} />
          <Route path="/email-address-result" component={ErrorMail} />

          {/* 請求情報の画面 */}
          <PrivateRoute path="/requestInformation" component={RequestInformation} exact />
          {/* 領収書発行の画面 */}
          <PrivateRoute path="/receipt" component={Receipt} exact />

          {/* 休会・休会取消の画面 */}
          <PrivateRoute path="/recess" component={Recess} exact />
          {/* 休会ルールの画面 */}
          <PrivateRoute path="/recess/recess-info" component={Recess_Info} exact />
          {/* 休会開始月選択の画面 */}
          <PrivateRoute path="/recess/month-start" component={Month_start} exact />
          {/* 休会終了月選択の画面 */}
          <PrivateRoute path="/recess/month-end" component={Month_end} exact />
          {/* 休会選択月確認の画面 */}
          <PrivateRoute path="/recess/recess-aggrement" component={Recess_agreement} exact />
          {/* 休会完了の画面 */}
          <PrivateRoute path="/recess/recess-complete" component={Recess_complete} exact />
          {/* 休会取消月確認の画面 */}
          <PrivateRoute path="/recess/recess-cancel-agreement" component={Recess_cancel_agreement} exact />
          {/* 休会取消完了の画面 */}
          <PrivateRoute path="/recess/recess-cancel-complete" component={Recess_cancel_complete} exact />
          {/* 各種手続きの画面 */}
          <PrivateRoute path="/otherOptions" component={OtherOptions} exact />
          {/* 予約の画面 - 店舗一覧 */}
          <PrivateRoute path="/reservation" component={ShopList} exact />
          {/* 予約履歴の画面 */}
          <PrivateRoute path="/history" component={ReservationHistory} exact />

          <PrivateRoute path="/reservation/schedule" component={Schedule} exact />

          <Route path="*" component={Error404} />
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default App;
